export const categories = [
  { slug: 'sousuo', name: '搜索引擎', icon: 'ri-search-line' },
  { slug: 'xinwen', name: '新闻资讯', icon: 'ri-newspaper-line' },
  { slug: 'shipin', name: '视频娱乐', icon: 'ri-video-line' },
  { slug: 'gouwu', name: '购物消费', icon: 'ri-shopping-cart-line' },
  { slug: 'shejiao', name: '社交社区', icon: 'ri-group-line' },
  { slug: 'xuexi', name: '学习教育', icon: 'ri-book-open-line' },
  { slug: 'shenghuo', name: '生活服务', icon: 'ri-home-heart-line' },
  { slug: 'gongju', name: '实用工具', icon: 'ri-tools-line' },
  { slug: 'jinrong', name: '金融理财', icon: 'ri-funds-line' },
  { slug: 'lvyou', name: '旅游出行', icon: 'ri-flight-takeoff-line' },
  { slug: 'yinyue', name: '音乐音频', icon: 'ri-music-line' },
  { slug: 'yundong', name: '体育健身', icon: 'ri-football-line' },
];

export const sites = [
  { id: 's1', name: '百度', url: 'https://www.baidu.com', description: '全球最大的中文搜索引擎，提供网页、图片、视频等搜索服务', category: 'sousuo', tags: ['搜索', '中文'] },
  { id: 's2', name: 'Google', url: 'https://www.google.com', description: '全球最受欢迎的搜索引擎，提供精准、快速的搜索体验', category: 'sousuo', tags: ['搜索', '全球'] },
  { id: 's3', name: '必应', url: 'https://www.bing.com', description: '微软推出的搜索引擎，集成AI智能搜索功能', category: 'sousuo', tags: ['搜索', 'AI'] },
  { id: 's4', name: '搜狗', url: 'https://www.sogou.com', description: '搜狗搜索，支持微信、知乎等平台内容搜索', category: 'sousuo', tags: ['搜索', '微信'] },
  { id: 's5', name: '360搜索', url: 'https://www.so.com', description: '360旗下搜索引擎，主打安全搜索体验', category: 'sousuo', tags: ['搜索', '安全'] },
  { id: 's6', name: '新浪新闻', url: 'https://news.sina.com.cn', description: '新浪新闻中心，提供24小时滚动新闻报道', category: 'xinwen', tags: ['新闻', '综合'] },
  { id: 's7', name: '腾讯新闻', url: 'https://news.qq.com', description: '腾讯新闻，实时推送国内外重大新闻事件', category: 'xinwen', tags: ['新闻', '实时'] },
  { id: 's8', name: '网易新闻', url: 'https://news.163.com', description: '网易新闻，有态度的新闻门户，深度报道与评论', category: 'xinwen', tags: ['新闻', '深度'] },
  { id: 's9', name: '今日头条', url: 'https://www.toutiao.com', description: '基于算法推荐的新闻资讯聚合平台', category: 'xinwen', tags: ['新闻', '推荐'] },
  { id: 's10', name: '知乎', url: 'https://www.zhihu.com', description: '中文互联网高质量的问答社区和创作者聚集的原创内容平台', category: 'xinwen', tags: ['问答', '知识'] },
  { id: 's11', name: 'B站', url: 'https://www.bilibili.com', description: '国内知名的视频弹幕网站，涵盖动画、游戏、知识等领域', category: 'shipin', tags: ['视频', '弹幕'] },
  { id: 's12', name: '优酷', url: 'https://www.youku.com', description: '阿里巴巴旗下视频平台，海量影视剧、综艺资源', category: 'shipin', tags: ['视频', '影视'] },
  { id: 's13', name: '爱奇艺', url: 'https://www.iqiyi.com', description: '领先的在线视频平台，丰富的正版高清视频内容', category: 'shipin', tags: ['视频', '影视'] },
  { id: 's14', name: '腾讯视频', url: 'https://v.qq.com', description: '腾讯旗下综合视频平台，海量热门影视综艺', category: 'shipin', tags: ['视频', '综艺'] },
  { id: 's15', name: '抖音', url: 'https://www.douyin.com', description: '字节跳动旗下短视频社交平台，记录美好生活', category: 'shipin', tags: ['短视频', '社交'] },
  { id: 's16', name: '淘宝', url: 'https://www.taobao.com', description: '阿里巴巴旗下C2C购物平台，万能的淘宝', category: 'gouwu', tags: ['购物', 'C2C'] },
  { id: 's17', name: '京东', url: 'https://www.jd.com', description: '自营电商平台，正品保障与高效物流配送', category: 'gouwu', tags: ['购物', '自营'] },
  { id: 's18', name: '拼多多', url: 'https://www.pinduoduo.com', description: '新电商开创者，拼着买更便宜', category: 'gouwu', tags: ['购物', '拼团'] },
  { id: 's19', name: '天猫', url: 'https://www.tmall.com', description: '阿里巴巴旗下B2C购物平台，品牌旗舰店聚集地', category: 'gouwu', tags: ['购物', '品牌'] },
  { id: 's20', name: '苏宁易购', url: 'https://www.suning.com', description: '苏宁旗下综合购物平台，家电3C品类齐全', category: 'gouwu', tags: ['购物', '家电'] },
  { id: 's21', name: '微信', url: 'https://weixin.qq.com', description: '腾讯旗下即时通讯软件，连接每一个人的生活', category: 'shejiao', tags: ['社交', '通讯'] },
  { id: 's22', name: '微博', url: 'https://weibo.com', description: '社交网络平台，随时随地发现新鲜事', category: 'shejiao', tags: ['社交', '资讯'] },
  { id: 's23', name: '豆瓣', url: 'https://www.douban.com', description: '文艺青年聚集地，书影音评分与社区讨论', category: 'shejiao', tags: ['社交', '文艺'] },
  { id: 's24', name: '小红书', url: 'https://www.xiaohongshu.com', description: '生活方式分享社区，种草拔草一网打尽', category: 'shejiao', tags: ['社交', '种草'] },
  { id: 's25', name: '中国大学MOOC', url: 'https://www.icourse163.org', description: '汇集国内顶尖高校优质在线课程', category: 'xuexi', tags: ['教育', 'MOOC'] },
  { id: 's26', name: '网易公开课', url: 'https://open.163.com', description: '免费观看世界名校公开课、TED演讲', category: 'xuexi', tags: ['教育', '公开课'] },
  { id: 's27', name: 'CSDN', url: 'https://www.csdn.net', description: '全球知名中文IT技术交流平台', category: 'xuexi', tags: ['IT', '技术'] },
  { id: 's28', name: 'GitHub', url: 'https://github.com', description: '全球最大的代码托管与开发者协作平台', category: 'xuexi', tags: ['编程', '开源'] },
  { id: 's29', name: 'WPS', url: 'https://www.wps.cn', description: '金山办公旗下云端办公套件，多人实时协作', category: 'xuexi', tags: ['办公', '协作'] },
  { id: 's30', name: '大众点评', url: 'https://www.dianping.com', description: '本地生活信息及交易平台，发现好去处', category: 'shenghuo', tags: ['生活', '本地'] },
  { id: 's31', name: '美团', url: 'https://www.meituan.com', description: '吃喝玩乐全都有，外卖配送、到店消费一站式服务', category: 'shenghuo', tags: ['生活', '外卖'] },
  { id: 's32', name: '58同城', url: 'https://www.58.com', description: '分类信息平台，找工作、租房、二手交易', category: 'shenghuo', tags: ['生活', '分类'] },
  { id: 's33', name: '贝壳找房', url: 'https://www.ke.com', description: '房源信息平台，VR看房真实房源', category: 'shenghuo', tags: ['房产', '租房'] },
  { id: 's34', name: '高德地图', url: 'https://www.amap.com', description: '精准地图导航与路线规划服务', category: 'shenghuo', tags: ['地图', '导航'] },
  { id: 's35', name: '在线PS', url: 'https://www.uupoop.com', description: '在线免费图片编辑工具，无需安装即开即用', category: 'gongju', tags: ['工具', '设计'] },
  { id: 's36', name: '草料二维码', url: 'https://cli.im', description: '二维码生成与美化工具，支持多种类型', category: 'gongju', tags: ['工具', '二维码'] },
  { id: 's37', name: 'ProcessOn', url: 'https://www.processon.com', description: '免费在线流程图、思维导图制作工具', category: 'gongju', tags: ['工具', '绘图'] },
  { id: 's38', name: '百度网盘', url: 'https://pan.baidu.com', description: '百度旗下云存储服务，超大空间文件存储', category: 'gongju', tags: ['云盘', '存储'] },
  { id: 's39', name: '站长工具', url: 'https://tool.chinaz.com', description: '站长之家出品的SEO综合查询工具', category: 'gongju', tags: ['SEO', '站长'] },
  { id: 's40', name: '支付宝', url: 'https://www.alipay.com', description: '蚂蚁集团旗下支付平台，安全便捷的电子支付', category: 'jinrong', tags: ['支付', '金融'] },
  { id: 's41', name: '东方财富', url: 'https://www.eastmoney.com', description: '领先的互联网财经信息平台，股票行情与资讯', category: 'jinrong', tags: ['财经', '股票'] },
  { id: 's42', name: '雪球', url: 'https://xueqiu.com', description: '聪明的投资者都在这里，股票投资交流社区', category: 'jinrong', tags: ['投资', '社区'] },
  { id: 's43', name: '招商银行', url: 'https://www.cmbchina.com', description: '领先的零售银行，提供全面的个人金融服务', category: 'jinrong', tags: ['银行', '理财'] },
  { id: 's44', name: '携程', url: 'https://www.ctrip.com', description: '在线旅游服务商，机票酒店火车票一站预订', category: 'lvyou', tags: ['旅游', '预订'] },
  { id: 's45', name: '去哪儿', url: 'https://www.qunar.com', description: '旅游搜索引擎，帮您找到性价比最高的旅行产品', category: 'lvyou', tags: ['旅游', '搜索'] },
  { id: 's46', name: '马蜂窝', url: 'https://www.mafengwo.cn', description: '旅游攻略社区，自由行爱好者的分享平台', category: 'lvyou', tags: ['旅游', '攻略'] },
  { id: 's47', name: '飞猪', url: 'https://www.fliggy.com', description: '阿里巴巴旗下旅行平台，年轻用户的旅行选择', category: 'lvyou', tags: ['旅游', '年轻'] },
  { id: 's48', name: 'QQ音乐', url: 'https://y.qq.com', description: '腾讯旗下音乐平台，海量正版音乐在线收听', category: 'yinyue', tags: ['音乐', '在线'] },
  { id: 's49', name: '网易云音乐', url: 'https://music.163.com', description: '发现与分享好音乐，以歌单和评论为核心的社区', category: 'yinyue', tags: ['音乐', '社区'] },
  { id: 's50', name: '酷狗音乐', url: 'https://www.kugou.com', description: '国内老牌音乐平台，丰富的音乐资源库', category: 'yinyue', tags: ['音乐', '曲库'] },
  { id: 's51', name: '虎扑', url: 'https://www.hupu.com', description: '中文最大的体育社区，NBA、足球等赛事讨论', category: 'yundong', tags: ['体育', '社区'] },
  { id: 's52', name: 'Keep', url: 'https://www.keep.com', description: '移动健身教练，随时随地完成训练课程', category: 'yundong', tags: ['健身', '运动'] },
];

export const articles = [
  {
    slug: '2026-shangban-changyong-gongju',
    title: '2026年上班族必备的10款高效办公工具推荐',
    excerpt: '提升工作效率从选对工具开始。本文精选了2026年最值得上班族使用的10款效率工具，涵盖文档协作、时间管理、远程会议等场景，让你的工作效率翻倍。',
    content: `<p>在快节奏的现代工作环境中，选择合适的办公工具可以显著提升工作效率。以下是2026年上班族必备的10款高效办公工具推荐：</p>
<h3>1. WPS Office —— 国产办公套件首选</h3>
<p>WPS Office已成为国内办公软件的主流选择，其云端协作功能让团队协作更加便捷。支持多人实时编辑文档、表格和演示文稿，完美替代传统Office软件。2026年版本还新增了AI智能写作助手，可以帮你快速生成会议纪要、周报等常用文档。</p>
<h3>2. 飞书 —— 新一代企业协作平台</h3>
<p>字节跳动出品的飞书整合了即时通讯、文档协作、日历管理、视频会议等功能，一站式解决团队沟通与协作需求。其多维表格功能尤其强大，可以用表格管理项目进度、OKR目标等。</p>
<h3>3. 石墨文档 —— 轻量级在线文档</h3>
<p>石墨文档以其简洁的界面和流畅的协作体验著称，适合需要快速创建和分享文档的场景。支持Markdown编辑，对技术团队特别友好。</p>
<h3>4. Notion —— 全能型笔记与知识管理</h3>
<p>Notion将笔记、数据库、看板、日历等功能融为一体，是个人知识管理和团队项目管理的利器。2026年的AI功能升级让信息整理更加智能化。</p>
<h3>5. ProcessOn —— 在线绘图工具</h3>
<p>免费在线流程图、思维导图、原型图制作工具，无需安装即可使用。支持团队协作编辑，是产品经理和设计师的得力助手。</p>
<h3>6. 腾讯会议 —— 稳定的视频会议</h3>
<p>经过多年迭代，腾讯会议已成为国内最稳定的视频会议工具之一。支持屏幕共享、虚拟背景、会议录制等功能，满足各种远程协作需求。</p>
<h3>7. 滴答清单 —— 高效任务管理</h3>
<p>跨平台任务管理工具，支持GTD时间管理方法。可以设置重复任务、子任务、优先级，帮你合理规划每一天的工作。</p>
<h3>8. 百度网盘 —— 云端文件管理</h3>
<p>大容量云存储服务，支持文件自动备份、在线预览、团队共享。企业版还提供了更强大的权限管理和安全功能。</p>
<h3>9. Canva —— 在线设计平台</h3>
<p>即使没有设计基础，也能用Canva快速制作精美的海报、PPT、社交媒体图片。海量模板让设计变得简单高效。</p>
<h3>10. DeepSeek —— AI智能助手</h3>
<p>2026年最值得使用的国产AI助手，支持长文本处理、代码编写、数据分析等多种场景，是提升工作效率的秘密武器。</p>
<p>以上10款工具覆盖了办公协作、时间管理、设计创作等常见工作场景。选择适合自己工作流程的工具，让2026年的工作效率大幅提升！</p>`,
    date: '2026-08-05',
    category: 'gongju',
    categoryName: '实用工具',
  },
  {
    slug: 'ai-sousuo-2026-qushi',
    title: 'AI搜索引擎全面对比：2026年谁才是最强搜索利器？',
    excerpt: '从ChatGPT Search到Perplexity，从百度AI搜索到秘塔，AI正在重塑搜索体验。本文深度对比主流AI搜索引擎，帮你找到最适合的智能搜索工具。',
    content: `<p>2026年，AI搜索引擎已经从概念走向了主流应用。各家搜索引擎纷纷集成AI能力，新的AI原生搜索产品也层出不穷。本文将全面对比当前主流的AI搜索引擎。</p>
<h3>一、传统搜索巨头的AI转型</h3>
<p><strong>百度AI搜索：</strong>作为国内搜索市场的领导者，百度在2026年将文心大模型深度集成到搜索结果中。用户可以在搜索结果页面直接获得AI生成的摘要回答，并支持多轮对话追问。优势在于中文内容索引的全面性，AI回答能够引用丰富的国内网页资源。</p>
<p><strong>Google SGE（Search Generative Experience）：</strong>Google的AI搜索体验已向全球开放。Gemini模型驱动的搜索能够理解复杂问题，提供综合性的AI概述。作为全球最大的搜索引擎，其数据覆盖面和准确性在英文内容上有明显优势。</p>
<p><strong>微软必应AI：</strong>深度整合GPT-5的必应搜索提供了流畅的对话式搜索体验。特别在技术文档搜索和编程相关查询上表现出色，得益于GitHub生态的加持。</p>
<h3>二、AI原生搜索引擎崛起</h3>
<p><strong>Perplexity AI：</strong>作为AI原生搜索的先驱，Perplexity在2026年依然保持着出色的表现。其实时联网搜索能力和精确的来源引用让用户可以验证信息的可靠性。Pro版本还支持文件上传分析和高级搜索策略。</p>
<p><strong>秘塔AI搜索：</strong>国内最受欢迎的AI搜索产品之一，支持学术搜索、深度搜索等多种模式。在中文长文本理解和学术文献搜索上有独特优势，是研究人员的得力工具。</p>
<p><strong>天工AI搜索：</strong>昆仑万维推出的AI搜索产品，支持多模态搜索，可以同时搜索文字、图片和视频内容。在处理多媒体信息查询时有独特优势。</p>
<h3>三、如何选择适合的AI搜索引擎？</h3>
<p>选择AI搜索引擎主要考虑以下几点：</p>
<p>1. <strong>语言需求：</strong>中文内容查询优先选择百度AI搜索或秘塔；英文或跨语言查询选择Google SGE或Perplexity。</p>
<p>2. <strong>使用场景：</strong>日常搜索用百度AI搜索或必应AI即可；学术研究推荐秘塔；编程技术推荐必应AI或Perplexity。</p>
<p>3. <strong>准确性要求：</strong>需要严格验证信息时，优先选择提供明确来源引用的Perplexity和秘塔。</p>
<p>4. <strong>多媒体需求：</strong>需要搜索图片、视频等内容时，天工AI搜索和Google SGE是不错的选择。</p>
<p>AI搜索正在让信息获取变得更加高效和智能，选择适合自己的工具，让搜索体验升级！</p>`,
    date: '2026-08-03',
    category: 'sousuo',
    categoryName: '搜索引擎',
  },
  {
    slug: '2026-shipin-pingtai-tuijian',
    title: '2026年最受欢迎的视频平台大盘点：追剧、学习、娱乐一网打尽',
    excerpt: '从长视频到短视频，从影视综艺到知识学习，视频平台的内容生态日益丰富。本文为你梳理2026年最值得关注的视频平台及其特色内容。',
    content: `<p>视频已经成为互联网内容消费的主要形式。2026年，各大视频平台的内容生态更加丰富多元，本文带您了解最受欢迎的视频平台。</p>
<h3>长视频平台：精品内容主战场</h3>
<p><strong>B站（哔哩哔哩）：</strong>从二次元弹幕网站成长为综合性视频社区，B站2026年在知识区、科技区和纪录片领域持续发力。弹幕文化营造了独特的社区氛围，UP主创作的优质内容让B站成为年轻用户的首选视频平台。</p>
<p><strong>爱奇艺：</strong>自制剧和综艺依然是爱奇艺的核心竞争力。2026年爱奇艺在悬疑剧赛道上持续产出爆款，迷雾剧场已成为品质国产剧的代名词。</p>
<p><strong>腾讯视频：</strong>依托腾讯生态的IP优势，腾讯视频在动漫和综艺领域有独特竞争力。《斗罗大陆》、《完美世界》等年番动画持续更新，吸引了大量忠实观众。</p>
<p><strong>优酷：</strong>阿里大文娱旗下的优酷在2026年重点发力纪录片和历史剧赛道，同时在港剧资源上有独家优势。</p>
<h3>短视频平台：碎片化内容之王</h3>
<p><strong>抖音：</strong>依然是短视频领域的绝对王者。2026年抖音在电商、本地生活和知识内容上持续拓展，已不仅仅是娱乐平台，更是生活服务平台。</p>
<p><strong>快手：</strong>以"拥抱每一种生活"为理念，快手在2026年保持了在下沉市场和特定垂直领域的优势。直播带货和本地生活服务是其核心增长点。</p>
<p><strong>微信视频号：</strong>依托微信13亿月活用户，视频号已成为不可忽视的短视频力量。在私域流量运营和熟人社交传播上有天然优势。</p>
<h3>中视频与特色平台</h3>
<p><strong>西瓜视频：</strong>字节跳动旗下的中视频平台，以3-15分钟的精品视频内容为主，与抖音形成差异化互补。</p>
<p><strong>小红书视频：</strong>小红书在生活方式领域的视频内容增长迅猛，种草视频、Vlog和教程类内容是其主要特色。</p>
<p>选择合适的视频平台，可以让你的娱乐、学习和生活更加丰富多彩！</p>`,
    date: '2026-07-28',
    category: 'shipin',
    categoryName: '视频娱乐',
  },
  {
    slug: 'wangshang-gouwu-shengqian-jiqiao',
    title: '网购达人都在用的省钱技巧：2026年各大电商平台优惠攻略',
    excerpt: '如何在淘宝、京东、拼多多等电商平台上用最少的钱买到最好的商品？本文整理了资深网购达人的实战经验，从比价到返利，全方位教你省钱购物。',
    content: `<p>网购已经成为人们日常生活的重要组成部分。掌握正确的省钱技巧，每年可以为你节省可观的购物开支。以下是2026年各大电商平台的省钱攻略。</p>
<h3>淘宝/天猫省钱技巧</h3>
<p><strong>1. 88VIP会员：</strong>如果你是淘宝重度用户，开通88VIP会员可以享受天猫超市、天猫国际等频道的专属折扣，同时赠送优酷、饿了么等会员权益，性价比极高。</p>
<p><strong>2. 淘金币抵扣：</strong>日常签到领取淘金币，下单时可以直接抵扣现金。积少成多，一年下来可以省不少钱。</p>
<p><strong>3. 大促期间集中采购：</strong>618、双11、年货节等大促期间，天猫的跨店满减和店铺优惠券可以叠加使用，是囤货的最佳时机。</p>
<h3>京东省钱攻略</h3>
<p><strong>1. PLUS会员：</strong>京东PLUS会员的10倍京豆返还和运费券是最实用的权益。如果经常在京东购物，PLUS会员几乎是必开的。</p>
<p><strong>2. 领券中心：</strong>京东领券中心的优惠券种类丰富，特别是家电数码品类的专属券，配合PLUS会员价使用可以拿到全网最低价。</p>
<p><strong>3. 白条免息：</strong>购买大件商品时使用京东白条免息分期，既减轻一次性付款压力，又不增加额外成本。</p>
<h3>拼多多省钱秘籍</h3>
<p><strong>1. 百亿补贴：</strong>拼多多的百亿补贴频道是购买品牌商品的超值选择，价格通常低于其他平台。每日更新补贴商品，建议养成每天浏览的习惯。</p>
<p><strong>2. 多多果园/牧场：</strong>通过小游戏免费获取水果和日用品，虽然需要一些时间成本，但确实能拿到实物。</p>
<p><strong>3. 限时秒杀：</strong>拼多多的限时秒杀商品价格极其诱人，但手速要快！提前加购并设定闹钟是抢到秒杀商品的秘诀。</p>
<h3>通用省钱技巧</h3>
<p><strong>1. 比价工具：</strong>使用一淘、慢慢买等比价工具，可以查看商品的历史价格走势，避免在价格高点入手。</p>
<p><strong>2. 返利App：</strong>通过返利App跳转下单，可以获得一定比例的返利。虽然单笔金额不大，但长期累积相当可观。</p>
<p><strong>3. 关注品牌会员日：</strong>很多品牌旗舰店每月都有会员日，当天通常有额外的折扣和赠品。</p>
<p><strong>4. 合理凑单：</strong>利用跨店满减规则合理凑单，但不要为了凑单而购买不需要的商品，否则反而浪费钱。</p>
<p>掌握这些省钱技巧，让你的每一分钱都花在刀刃上！</p>`,
    date: '2026-07-25',
    category: 'gouwu',
    categoryName: '购物消费',
  },
  {
    slug: '2026-zaixian-jiaoyu-xuexi-pingtai',
    title: '终身学习时代：2026年最优质的在线学习平台推荐',
    excerpt: '在知识快速迭代的时代，持续学习已成为每个人必备的能力。本文推荐了国内外最优质的在线学习平台，涵盖职业技能、兴趣爱好和学术研究等多个领域。',
    content: `<p>技术的飞速发展让终身学习不再是口号，而是每个人职业生涯的必需品。2026年，在线学习平台的内容质量和用户体验都有了质的飞跃。以下是推荐的学习平台。</p>
<h3>国内优质学习平台</h3>
<p><strong>中国大学MOOC：</strong>由网易与高教社联合推出，汇集了清华、北大等国内顶尖高校的优质课程。课程内容涵盖计算机、经济管理、人文社科等各个领域，完成课程后还可以获得证书。2026年平台新增了AI辅助学习功能，可以根据你的学习进度智能推荐复习内容。</p>
<p><strong>网易公开课：</strong>收录了TED演讲、国际名校公开课等大量优质视频内容，配有中文字幕。适合想拓展国际视野的学习者。</p>
<p><strong>极客时间：</strong>专注于IT技术领域的知识付费平台，课程由行业一线专家讲授。适合技术人员系统化提升专业技能。</p>
<p><strong>得到：</strong>罗振宇创办的知识服务平台，以音频课程和电子书为核心产品。适合碎片化时间学习的职场人士。</p>
<h3>国际知名学习平台</h3>
<p><strong>Coursera：</strong>全球最大的在线学习平台之一，与斯坦福、耶鲁等世界名校合作提供课程。支持中文字幕的课程越来越多，国际化学习的门槛大大降低。</p>
<p><strong>Udemy：</strong>课程种类最丰富的在线学习平台，从编程到烹饪应有尽有。课程经常有大幅折扣，性价比很高。</p>
<p><strong>Khan Academy：</strong>完全免费的非营利教育平台，从基础数学到大学先修课程，内容质量极高。适合学生群体和想要巩固基础知识的自学者。</p>
<h3>学习建议</h3>
<p>1. <strong>明确学习目标：</strong>选择课程前先确定自己想达成什么目标，避免盲目学习。</p>
<p>2. <strong>制定学习计划：</strong>为每门课程设定完成时间，保持学习的节奏感。</p>
<p>3. <strong>学以致用：</strong>学了就要用，通过实践项目巩固所学知识。</p>
<p>4. <strong>加入学习社区：</strong>和志同道合的人一起学习，互相监督和鼓励。</p>
<p>在这个快速变化的时代，投资学习永远是最划算的投资。</p>`,
    date: '2026-07-20',
    category: 'xuexi',
    categoryName: '学习教育',
  },
  {
    slug: 'shejiao-meiti-2026-bianju',
    title: '社交媒体2026新格局：从流量为王到价值为王的转型之路',
    excerpt: '社交媒体正在经历深刻变革，内容质量、社区氛围和用户价值成为新的竞争焦点。本文分析了2026年社交媒体的最新趋势和各平台的发展方向。',
    content: `<p>2026年的社交媒体格局正在经历一场深刻的变革。流量红利消退后，各平台纷纷从"流量为王"转向"价值为王"，更加注重内容质量和用户体验。</p>
<h3>微信生态：私域运营的核心阵地</h3>
<p>微信月活用户已突破14亿，其生态的完整性无出其右。2026年，视频号已成为微信生态中最活跃的内容载体，公众号+视频号+企业微信+小程序的组合拳，让微信成为企业和创作者私域运营的不二之选。视频号直播带货的GMV持续攀升，已成为电商领域不可忽视的力量。</p>
<h3>微博：公共议题的舆论场</h3>
<p>微博依然是中文互联网最重要的公共讨论空间。2026年微博加强了垂直领域的内容建设，在娱乐、体育、科技等赛道深耕，同时优化了热搜机制的透明度和内容质量，让优质内容更容易被看见。</p>
<h3>小红书：生活方式决策入口</h3>
<p>小红书在2026年已经从一个"种草"平台成长为年轻人的综合生活方式决策入口。用户在做出消费决策（旅游、餐饮、穿搭、家居等）前，都会到小红书搜索相关笔记。平台对真实内容的鼓励机制让信息质量保持在较高水平。</p>
<h3>知乎：深度内容的守护者</h3>
<p>在碎片化阅读的时代，知乎依然坚持深度内容的定位。2026年的知乎在AI问答、专业认证和付费咨询等方向持续探索，为知识创作者提供更多变现途径。</p>
<h3>豆瓣：文艺社区的长青密码</h3>
<p>豆瓣以其独特的社区气质在社交媒体中保持着不可替代的位置。书影音评分依然是中文互联网最具公信力的参考之一，小组功能则创造了无数个小而美的兴趣社区。</p>
<h3>社交媒体使用建议</h3>
<p>1. <strong>信息获取多元化：</strong>不要只依赖一个平台获取信息，避免信息茧房。</p>
<p>2. <strong>注重内容质量：</strong>关注那些产出高质量内容的创作者，远离标题党和情绪化内容。</p>
<p>3. <strong>保护个人隐私：</strong>在社交平台分享时注意保护个人信息安全。</p>
<p>4. <strong>控制使用时间：</strong>合理规划社交媒体的使用时间，避免沉迷。</p>
<p>社交媒体是工具而非生活的全部，善用它，让生活更美好。</p>`,
    date: '2026-07-15',
    category: 'shejiao',
    categoryName: '社交社区',
  },
];

export const hotSites = [
  's1', 's11', 's16', 's17', 's18', 's22', 's24', 's40',
];

export const faqItems = [
  {
    question: '91导航是什么？',
    answer: '91导航是一站式网址导航与资源聚合平台，汇聚海量优质网址、热门工具和实用资源，帮助用户快速直达目标网站。无论办公、娱乐还是学习，91导航让您告别繁琐搜索，一键直达所需。',
  },
  {
    question: '如何使用91导航快速找到需要的网站？',
    answer: '您可以通过以下几种方式找到需要的网站：1）在首页搜索框中直接搜索网站名称或关键词；2）通过分类导航浏览不同类别的网站；3）查看首页"热门推荐"区域精选的热门网站。',
  },
  {
    question: '91导航收录的网站是如何筛选的？',
    answer: '91导航的编辑团队会从网站内容质量、用户体验、安全性和实用性等多个维度综合评估每一个收录的网站，确保推荐的网站安全可靠、真正有用。同时我们也会定期更新和维护网站列表。',
  },
  {
    question: '可以推荐网站给91导航收录吗？',
    answer: '当然可以！我们非常欢迎用户推荐优质网站。您可以通过"关于我们"页面的联系方式提交网站推荐，我们的编辑团队会在审核后决定是否收录。',
  },
  {
    question: '91导航是否收费？',
    answer: '91导航对所有用户完全免费。我们致力于为广大网民提供最优质的网址导航服务，不向用户收取任何费用。',
  },
];